<template>
  <div
    class="w-full col-span-full flex flex-row"
    @mousedown="isDragging = true"
    @mouseleave="isDragging = false"
    @mouseup="isDragging = false"
  >
    <div class="w-1/2">
      <info-bulle
        v-if="libelleLeft"
        :libelle="labelLibelle"
        :name="name"
        :is-libelle-input="true"
      >
        <template #libelleBefore>
          <p
            :for="name"
            v-html="textLibelleLeft"
            class="text-sm text-gray-600 truncate mb-2"
            :style="(inherits != undefined && inherits != null && inherits) ? 'color: inherit; font-size: inherit; font-weight: inherit;' : ''"
            @mouseover="tooltipLibelle=true;"
            @mouseleave="tooltipLibelle=false;"
          />
        </template>
        <template #tooltipLibelleBefore>
          <!-- Display libelle when hover -->
          <transition
            enter-active-class="duration-300 delay-1000"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="duration-300"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <div
              v-if="tooltipLibelle && libelleLeft != null && libelleLeft != ''"
              class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-8 z-30 p-3 text-sm w-max-content w-max max-w-128"
            >
              {{ libelleLeft }}
            </div>
          </transition>
        </template>
      </info-bulle>

      <div
        class="relative"
        @mouseover="tooltipValue=true;"
        @mouseleave="tooltipValue=false;"
      >
        <div

          class="absolute inset-y-0 left-0 flex items-center text-indigo-600 px-4 w-max"
        >
          <icon
            name="move"
            class="text-indigo-600"
            :class="{'mr-2' : prefixTextLeft.length > 0}"
          />
          <p
            class="text-sm font-normal text-gray-900 pt-0.5"
            v-if="prefixTextLeft.length > 0"
          >
            {{ prefixTextLeft }}
          </p>
        </div>

        <input
          :name="name"
          :min="min"
          :max="max"
          :necessary="progressCount"
          :required="isRequired"
          :autocomplete="'off'"
          class="border border-r-0 border-opacity-50 rounded-l-md
                            placeholder-gray-600
                            block w-full
                            focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300
                            appearance-none transition duration-150 ease-in-out
                            sm:leading-5 truncate"

          v-model="mutableValueLeft"
          :placeholder="placeholderLeft"
          :disabled="disabled || disabled_pass || !isEditable"
          :maxlength="maxlength"
          :class="{'bg-gray-200 cursor-not-allowed': disabled || disabled_pass,
                   'text-lg py-5 px-5': big != null && big,
                   'text-sm pl-6 pr-8 py-2 xxl:pl-10 xxl:pr-8 xxl:py-3 2xl:pl-10 2xl:pr-12 2xl:py-4': big == null || !big,
                   'pl-10 xxl:pl-14 2xl:pl-14': prefixTextLeft.length > 0,
                   'border-red-500': error && errorMsg != '',
                   'border-indigo-600': !(error && errorMsg != ''),
                   'pointer-events-none': !isEditable,
          }"
          style="background-color:inherit"
          :style="(isGrabable && !isEditable) ? 'cursor:grab': ''"
        >

        <div
          class="absolute inset-y-0 right-0 flex items-center border-r border-indigo-600 my-2"
        />


        <!-- Display value when hover -->
        <transition
          enter-active-class="duration-300 delay-300"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="duration-300"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="tooltipValue && mutableValueLeft != null && mutableValueLeft != '' && !isDragging"
            class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-12 z-30 p-3 text-sm w-max-content w-max max-w-128"
          >
            {{ mutableValueLeft }}
          </div>
        </transition>
      </div>
      <div
        v-if="error"
        class="text-red-500 text-sm"
      >
        {{ errorMsg }}
      </div>
    </div>

    <!--InputRight-->
    <div class="w-1/2">
      <info-bulle
        v-if="libelleRight"
        :libelle="labelLibelle"
        :name="name"
        :is-libelle-input="true"
      >
        <template #libelleBefore>
          <p
            :for="name"
            v-html="textLibelleRight"
            class="text-sm text-gray-600 truncate mb-2"
            :style="(inherits != undefined && inherits != null && inherits) ? 'color: inherit; font-size: inherit; font-weight: inherit;' : ''"
            @mouseover="tooltipLibelle=true;"
            @mouseleave="tooltipLibelle=false;"
          />
        </template>
        <template #tooltipLibelleBefore>
          <!-- Display libelle when hover -->
          <transition
            enter-active-class="duration-300 delay-1000"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="duration-300"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <div
              v-if="tooltipLibelle && libelleRight != null && libelleRight != ''"
              class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-8 z-30 p-3 text-sm w-max-content w-max max-w-128"
            >
              {{ libelleRight }}
            </div>
          </transition>
        </template>
      </info-bulle>

      <div
        class="relative"
        @mouseover="tooltipValue=true;"
        @mouseleave="tooltipValue=false;"
      >
        <div

          class="absolute inset-y-0 left-0 flex items-center text-indigo-600 px-4 w-max"
        >
          <p
            class="text-sm font-normal text-gray-900 pt-0.5"
            v-if="prefixTextRight.length > 0"
          >
            {{ prefixTextRight }}
          </p>
        </div>

        <input
          :name="name"
          :min="min"
          :max="max"
          :necessary="progressCount"
          :required="isRequired"
          :autocomplete="'off'"
          class="border border-l-0 border-opacity-50 rounded-r-md
                            placeholder-gray-600
                            block w-full
                            focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300
                            appearance-none transition duration-150 ease-in-out
                            sm:leading-5 truncate"

          v-model="mutableValueRight"
          :placeholder="placeholderRight"
          :disabled="disabled || disabled_pass || !isEditable"
          :maxlength="maxlength"
          :class="{'bg-gray-200 cursor-not-allowed': disabled || disabled_pass,
                   'text-lg py-5 px-5': big != null && big,
                   'text-sm pl-6 pr-8 py-2 xxl:pl-10 xxl:pr-8 xxl:py-3 2xl:pl-10 2xl:pr-12 2xl:py-4': big == null || !big,
                   'pl-6 xxl:pl-10 2xl:pl-10': prefixTextRight.length > 0,
                   'border-red-500': error && errorMsg != '',
                   'border-indigo-600': !(error && errorMsg != ''),
                   'pointer-events-none': !isEditable,
          }"
          style="background-color:inherit"
          :style="(isGrabable && !isEditable) ? 'cursor:grab': ''"
        >

        <div
          v-if="!(disabled || disabled_pass) && !isEditable"
          class="absolute inset-y-0 right-0 flex items-center text-pink-600 px-4 cursor-pointer w-max"
          @click.stop="displayMenu()"
        >
          <icon name="more-vertical" />
        </div>

        <div
          v-if="!(disabled || disabled_pass) && isEditable"
          class="absolute inset-y-0 right-0 flex items-center cursor-pointer text-teal-400 px-4 w-max"
          @click.prevent="switchEditable(false)"
        >
          <icon
            name="checkmark-circle"
            class="text-teal-600"
          />
        </div>

        <div
          v-if="isMenuDisplayed && !isEditable"
          class="menu-input
                        z-20 absolute -right-8 top-10
                        text-sm w-max
                        bg-white rounded-md
                        shadow-md shadow-gray-600
                        px-6 py-5
                        cursor-default
                        flex flex-col space-y-1
                    "
          :name="'menu'+name"
          v-clickOutside="forceHide"
        >
          <div
            @click.stop="switchEditable(true)"
            class="text-gray-600 hover:text-gray-900 cursor-pointer"
          >
            Modifier
          </div>
          <div
            @click.stop="duplicate()"
            class="text-gray-600 hover:text-gray-900 cursor-pointer"
          >
            Dupliquer
          </div>
          <div
            @click.stop="deleteIt()"
            class="text-gray-600 hover:text-gray-900 cursor-pointer"
          >
            Supprimer
          </div>
        </div>

        <!-- Display value when hover -->
        <transition
          enter-active-class="duration-300 delay-300"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="duration-300"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="tooltipValue && mutableValueRight != null && mutableValueRight != '' && !isDragging"
            class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-12 z-30 p-3 text-sm w-max-content w-max max-w-128"
          >
            {{ mutableValueRight }}
          </div>
        </transition>
      </div>
      <div
        v-if="error"
        class="text-red-500 text-sm"
      >
        {{ errorMsg }}
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Icon from '../../components/Icon';
import InfoBulle from '../../components/InfoBulle';

export default {
  props: {
    name: String,
    libelleLeft: String,
    libelleRight: String,
    valueLeft: [String, Number],
    valueRight: [String, Number],
    necessary: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholderLeft: String,
    placeholderRight: String,
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    error: Boolean,
    msgError: {
      type: String,
      required:false,
      default:''
    },
    maxlength: Number,
    labelLibelle: String,
    big: Boolean,
    required: Boolean,
    inherits :{
      type: Boolean,
      required: false,
      default:false,
    },
    min: Number,
    max: Number,
    newPassword:{
      type:Boolean,
      required:false,
      default:false,
    },
    isGrabable:{
      type:Boolean,
      required:false,
      default:false,
    },
    orginColor:{
      type:Boolean,
      required:false,
      default:true,
    },
    draggable:{
      type:Boolean,
      required:false,
      default:false,
    },
    prefixTextLeft:{
      type:[String, Number],
      required: false,
      default:'',
    },
    prefixTextRight:{
      type:[String, Number],
      required: false,
      default:'',
    }
  },

  components:{
    Icon,
    InfoBulle,
  },

  data: function () {
    return {
      mutableValueLeft: this.valueLeft,
      mutableValueRight: this.valueRight,
      errorMsg: this.msgError,
      disabled_pass: false,
      tooltipLabel: false,
      tooltipValue: false,
      tooltipLibelle:false,
      progressCount:true,
      textLibelleLeft: '&nbsp;',
      textLibelleRight: '&nbsp;',
      isRequired:false,

      isMenuDisplayed:false,
      isEditable: false,
      isDragging: false,
    };
  },

  mounted(){
    // Manage edit permission for neopass pages
    if(this.$route.path.includes('form/neopass')){
      let idpass = this.$route.path.split('/form/neopass/')[1].split('/')[0];
      let page = this.$route.path.split('/form/neopass/')[1].split('/')[2];

      if(this.$can(page+'_edit', idpass)){
        this.disabled_pass = false;
      }
      else{
        this.disabled_pass =  true;
      }
    }else{
      this.disabled_pass = false;
    }

    //assign "necessary" prop value to "progressCount" data if this prop is filled
    if(this.necessary !== undefined && !this.necessary){
      this.progressCount = false;
    }

    //assign text to textLibelle if prop Libelle is filled
    if(this.libelleLeft !== undefined && this.libelleLeft != null){
      this.textLibelleLeft = this.libelleLeft;
    }

    //assign text to textLibelle if prop Libelle is filled
    if(this.libelleRight !== undefined && this.libelleRight != null){
      this.textLibelleRight = this.libelleRight;
    }

    //assign "required" prop value to "isRequired" data if this prop is filled
    if(this.required !== undefined && this.required != null){
      this.isRequired = this.required;
    }

    if(this.msgError){
      this.errorMsg = this.msgError;
    }

  },

  methods:{
    displayLabelTooltip(e){
      if(e.x < (2*window.outerWidth/3)){
        document.querySelectorAll('.tooltip-Label[name=\''+this.name+'\']')[0].classList.remove('right-0');
      }

      this.tooltipLabel = !this.tooltipLabel;
    },

    displayMenu(){
      this.isMenuDisplayed = !this.isMenuDisplayed;
    },

    forceHide(e){
      if(e.target.classList.contains('menu-input') && e.target.name == 'menu'+this.name && !this.disabled_pass){
        this.isMenuDisplayed = true;
      }else{
        if(this.isMenuDisplayed){
          this.isMenuDisplayed = false;
        }
      }
    },

    forceHideTooltipLabel(e){
      if(e.target.classList.contains('tooltip-Label') && e.target.name == this.name){
        this.tooltipLabel = !this.tooltipLabel;
      }else{
        if(this.tooltipLabel)
          this.tooltipLabel = false;
      }
    },

    switchEditable(state){
      this.isEditable = state;
      this.$emit('switchEditable', state);
    },

    duplicate(){
      this.$emit('duplicate');
      this.isMenuDisplayed = false;
    },

    deleteIt(){
      this.$emit('delete');
      this.isMenuDisplayed = false;
    }
  },

  watch: {
    mutableValueLeft() {
      this.$emit('inputLeft', this.mutableValueLeft);

      if(this.maxlength && this.mutableValueLeft && this.mutableValueLeft.length >= this.maxlength){
        this.errorMsg = 'Vous avez atteint la taille maximum de '+this.maxlength+' caractères.';
      }else if(this.maxlength && this.mutableValueLeft && this.mutableValueLeft.length < this.maxlength){
        this.errorMsg = '';
      }else if(this.msgError){
        this.errorMsg = this.msgError;
      }else{
        this.errorMsg = '';
      }
    },

    mutableValueRight() {
      this.$emit('inputRight', this.mutableValueRight);

      if(this.maxlength && this.mutableValueRight && this.mutableValueRight.length >= this.maxlength){
        this.errorMsg = 'Vous avez atteint la taille maximum de '+this.maxlength+' caractères.';
      }else if(this.maxlength && this.mutableValueRight && this.mutableValueRight.length < this.maxlength){
        this.errorMsg = '';
      }else if(this.msgError){
        this.errorMsg = this.msgError;
      }else{
        this.errorMsg = '';
      }
    },

    valueLeft(){
      this.mutableValueLeft = this.valueLeft;
    },

    valueRight(){
      this.mutableValueRight = this.valueRight;
    },

    msgError(){
      this.errorMsg = this.msgError;
    }
  },

  directives: {
    clickOutside:{
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) { warn += `Found in component '${compName}'`; }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
      },

      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
};
</script>
